module.exports = __webpack_public_path__ + "static/media/CEREMONIA_DE_DESPEDIDA.80dcf323.png";